import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Entryway / Foyer (Phase 13A). Gets the full shared category set
 * (flooring, painting, trim, lighting, built-ins, windows/doors) since a
 * foyer renovation commonly touches all of them at once - a statement
 * floor, a front door replacement, an upgraded light fixture, and a
 * closet/bench built-in are all typical scope for this project type, and
 * each is independently priced and gated exactly like every other Phase
 * 13A type rather than folded into one flat allowance.
 */
export const calculateEntrywayFoyer = createInteriorRoomCalculator({
  projectType: "entryway_foyer",
  anchorItemId: "entryway_foyer_base_renovation",
  tierFeatures: [
    {
      answerKey: "entryway_foyer_flooring_type",
      itemIdByTier: { not_changing: null, basic: "entryway_foyer_flooring_basic", mid_range: "entryway_foyer_flooring_mid", premium: "entryway_foyer_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "entryway_foyer_painting",
      itemIdByTier: { not_included: null, walls_only: "entryway_foyer_painting_walls", full_room: "entryway_foyer_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "entryway_foyer_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "entryway_foyer_trim_standard", premium_millwork: "entryway_foyer_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "entryway_foyer_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "entryway_foyer_lighting_standard", statement_lighting: "entryway_foyer_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate (a statement entry fixture is common scope here if selected)."
    },
    {
      answerKey: "entryway_foyer_built_ins",
      itemIdByTier: { none: null, standard: "entryway_foyer_built_ins_standard", custom: "entryway_foyer_built_ins_custom" },
      excludedMessage: "No closet/bench built-ins were requested - excluded from this estimate."
    },
    {
      answerKey: "entryway_foyer_windows_doors",
      itemIdByTier: { none: null, replace_existing: "entryway_foyer_windows_doors_replace", add_new: "entryway_foyer_windows_doors_add" },
      excludedMessage: "No front door/window changes were requested - excluded from this estimate."
    }
  ],
  electricalItemId: "entryway_foyer_electrical",
  demolitionItemId: "entryway_foyer_demolition",
  accessibilityItemId: "entryway_foyer_accessibility",
  permitDesignItemId: "entryway_foyer_permit_design"
});
